import { describeMutationError } from "@api/mutationErrors";
import {
  Button,
  ConfirmDialog,
  FieldError,
} from "@scribenote/brian-design-system";
import { useState } from "react";

import type { ListedDisplay } from "./displaysClient";
import { useRemoveDisplay } from "./displaysQueries";

export const DeleteDisplayButton = ({
  display,
  sessionKey,
}: {
  display: ListedDisplay;
  sessionKey: string;
}) => {
  const [confirming, setConfirming] = useState(false);
  const remove = useRemoveDisplay(sessionKey);

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        onClick={() => setConfirming(true)}
        className="text-ink-stopped"
        data-testid="admin-display-delete"
      >
        Delete
      </Button>

      <ConfirmDialog
        open={confirming}
        title={`Delete ${display.name}?`}
        confirmLabel="Delete"
        destructive
        busy={remove.isPending}
        onCancel={() => {
          remove.reset();
          setConfirming(false);
        }}
        onConfirm={() =>
          remove.mutate(display.id, { onSuccess: () => setConfirming(false) })
        }
        confirmTestId="admin-display-delete-confirm"
      >
        <p className="text-sm text-ink-body">
          {display.device
            ? "Its screen goes back to showing a pairing code. This can’t be undone."
            : "This can’t be undone."}
        </p>
        {remove.isError && (
          <FieldError className="mt-2">
            {describeMutationError(remove.error, "delete the display")}
          </FieldError>
        )}
      </ConfirmDialog>
    </>
  );
};
